import React from 'react';
import { TwitterAuthProvider, signInWithPopup } from 'firebase/auth';
import { authentication } from './firebase-config';
import { useAppDispatch, useAppTranslation } from 'app/hooks';
import { useHandleResponseError } from 'hooks/useHandleResponseError';
import useUserDetail from 'hooks/useUserDetail';
import authApi from 'api/auth';
import { setLocalStorage } from 'utils/sessionStorage';
import { onChangeAuthPage } from 'features/home/homeSlice';
import twitter_icon from 'assets/icons/twitter_icon.png';
import x_icon from 'assets/icons/x_white_icon.png';

interface TwitterAuthProps {}

const TwitterAuth: React.FunctionComponent<TwitterAuthProps> = () => {
  const dispatch = useAppDispatch();
  const handleResponseError = useHandleResponseError();
  const { getUserDetail } = useUserDetail();
  const t = useAppTranslation();

  const signInWithTwitter = () => {
    const provider = new TwitterAuthProvider();
    signInWithPopup(authentication, provider)
      .then(async (res) => {
        const credential = TwitterAuthProvider.credentialFromResult(res);
        const { ok, error, body } = await authApi.twitterLogin({
          accessToken: credential?.accessToken || '',
          secret: credential?.secret || '',
        });
        if (ok && body) {
          setLocalStorage('access_token_terabet', body.accessToken);
          dispatch(onChangeAuthPage(-1));
        }
        if (error) {
          handleResponseError(error);
        }
        getUserDetail();
      })
      .catch((error) => {
        handleResponseError(error);
      });
  };

  return <img src={x_icon} alt="twitter" className="x-btn" onClick={signInWithTwitter} />;
};

export default TwitterAuth;
